/**
 * Altura dos iframes Metabase.
 * Precisa ser alta o bastante para o dashboard inteiro caber no iframe —
 * senão o Metabase cria scroll interno. O scroll deve ser só da página.
 * (Cross-origin: não dá para medir a altura real do conteúdo.)
 */
export const METABASE_IFRAME_HEIGHT_CLASS = 'h-[5600px] min-h-[5600px]';

/** Skeleton de loading com a mesma altura do iframe. */
export const METABASE_IFRAME_SKELETON_CLASS = 'min-h-[5600px]';
